import { plainToInstance } from 'class-transformer'

import { GetPoisParamsReqDto } from '@/api/client/map/dto/mapDto'
import { GetPoisResDto } from '@/api/dto/poi'
import axios from '@/lib/axiosClient'

export const poiUrlEndpoint = '/poi'

/**
 * 지도검색 (핀조회 - 모드 분리)
 * @params {
  geohash!: string
  monthlyMode?: boolean
  shareMode?: boolean
  partnerMode?: boolean
}
 * @result {GetPoisResDto}
 */
export const fetchGetPois = async (params: GetPoisParamsReqDto): Promise<GetPoisResDto> => {
  const { data } = await axios.get<GetPoisResDto>(`${poiUrlEndpoint}/pins`, { params })
  return plainToInstance(GetPoisResDto, data)
}
